import { usePetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';

import { useDecisionMakers } from '../../../../hooks/useDecisionMakers';
import { useTracking } from '../../../../hooks/useTracking';
import type { BuildingBlockDms } from '../../../../shared/types';

type Result = ModelHookResult<
	{
		sortedAllDms: BuildingBlockDms;
		petitionAsk: string;
		viewAllText: string;
	},
	{ trackViewAllDMsClick: () => void }
>;

export function useViewAll(): Result {
	const {
		data: { sortedAllDms, totalDmCount },
	} = useDecisionMakers();
	const { trackViewAllDMsClick } = useTracking();

	const {
		data: {
			petition: { ask },
		},
	} = usePetitionDetailsPageData();

	return {
		data: {
			petitionAsk: ask,
			sortedAllDms,
			viewAllText: `View all ${totalDmCount} Decision Makers`,
		},
		actions: { trackViewAllDMsClick },
	};
}
